import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { Newspaper } from "lucide-react";

export const formatNewsDate = (iso, opts = { month: "short", day: "numeric", year: "numeric" }) =>
  iso ? new Date(iso).toLocaleDateString("en-US", opts) : "";

// Shows news articles linked to a team / player / match / competition. Renders nothing if none.
export const RelatedNews = ({ entity, id, title = "Related News" }) => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    if (!id) return;
    axios.get(`${API}/news`, { params: { [entity]: id, limit: 6 } })
      .then(r => setArticles(r.data))
      .catch(() => setArticles([]));
  }, [entity, id]);

  if (articles.length === 0) return null;

  return (
    <section className="py-12 px-4 md:px-8 bg-gray-50" data-testid={`related-news-${entity}`}>
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl font-bold uppercase text-[#09090b] mb-6 flex items-center gap-3">
          <Newspaper className="w-6 h-6 text-[#009E60]" /> {title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {articles.map(a => (
            <Link
              key={a.article_id}
              to={`/news/${a.slug || a.article_id}`}
              className="card-abfa group bg-white"
              data-testid={`related-news-card-${a.article_id}`}
            >
              {a.image_url && (
                <div className="aspect-video overflow-hidden">
                  <img src={a.image_url} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
              )}
              <div className="p-4">
                <p className="text-xs text-[#009E60] uppercase tracking-wider mb-2">{formatNewsDate(a.published_at)}</p>
                <h3 className="font-heading font-bold uppercase text-[#09090b] group-hover:text-[#009E60] transition-colors">{a.title}</h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
